














import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

const DayKeyNameMapping = {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun'
}

const DefaultFromTimeMapping = {
    mon: null,
    tue: null,
    wed: null,
    thu: null,
    fri: null,
    sat: null,
    sun: null
}

const DefaultToTimeMapping = {
    mon: null,
    tue: null,
    wed: null,
    thu: null,
    fri: null,
    sat: null,
    sun: null
}
interface Hours {
    startHour: number;
    endHour: number;
}

@Component({
    components: {}
})
export default class CommDay extends Vue {
    @Prop() dayKey!: 'mon'|'tue'|'wed'|'thu'|'fri'|'sat'|'sun'
    @Prop() value!: Hours[]
    @Prop({ default: true }) disabled!: boolean
    get startHour() { return this.value[0] ? Number(this.value[0].startHour) : 0 }
    set startHour(value) { this.value[0].startHour = Number(value) }
    get endHour() { return this.value[0] ? Number(this.value[0].endHour) : 0 }
    set endHour(value) { this.value[0].endHour = Number(value) }

    get dayName(): string {
        return DayKeyNameMapping[this.dayKey]
    }

    @Emit('input')
    handleInput() {
        return this.value
    }
}
